(() => {
  if (document.documentElement.dataset.nakedScrollBubbles !== 'true' || document.querySelector('.naked-bubbles')) return;
  const intensity = Math.max(1, Math.min(5, Number(document.documentElement.dataset.nakedBubbleIntensity) || 3));
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const layer = document.createElement('div');
  layer.className = 'naked-bubbles';
  layer.setAttribute('aria-hidden', 'true');
  document.body.append(layer);
  let lastBurst = -Infinity;
  let previousY = window.scrollY;
  const random = (min, max) => min + Math.random() * (max - min);
  const clear = () => layer.replaceChildren();
  const createBubble = () => {
    if (layer.childElementCount >= 16) return;
    const bubble = document.createElement('span');
    bubble.className = 'naked-bubble';
    const size = random(22, window.innerWidth < 768 ? 48 : 68);
    const edge = Math.min(window.innerWidth * .18, 160);
    const left = Math.random() < .5;
    const x = left ? random(5, edge) : random(window.innerWidth - edge - size, window.innerWidth - size - 5);
    bubble.style.setProperty('--bubble-x', `${x}px`);
    bubble.style.setProperty('--bubble-y', `${random(window.innerHeight * .3, window.innerHeight * .95)}px`);
    bubble.style.setProperty('--bubble-size', `${size}px`);
    bubble.style.setProperty('--bubble-drift', `${random(-35, 35)}px`);
    bubble.style.setProperty('--bubble-duration', `${random(2.8, 4.4)}s`);
    bubble.addEventListener('animationend', () => bubble.remove(), { once: true });
    layer.append(bubble);
  };
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const moved = Math.abs(y - previousY);
    previousY = y;
    if (motion.matches || document.hidden || moved < 2) return;
    const now = performance.now();
    if (now - lastBurst < 240) return;
    lastBurst = now;
    for (let i = 0; i < intensity; i++) createBubble();
  }, { passive: true });
  motion.addEventListener('change', clear);
  document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); });
  window.addEventListener('pagehide', clear);
})();

